import { TableCell } from "@mui/material"
import classNames from "classnames"
import { Icon, IconColor } from "@/components/shared/Icon"
import Tooltip from "@/components/shared/Tooltip"

export interface ActionsProps {
   isEditing: boolean
   hideDelete: boolean
   isDisabled: boolean
   isSaveDisabled?: boolean
   isEditDisabled?: boolean
   onEdit: () => void
   onSave: () => void
   onCancel: () => void
   onDelete: () => void
}

export function Actions({
   isEditing,
   hideDelete,
   isDisabled,
   isSaveDisabled = false,
   isEditDisabled = false,
   onEdit,
   onSave,
   onCancel,
   onDelete,
}: ActionsProps) {
   return (
      <TableCell
         className="table__cell table__cell--actions"
         align="right"
      >
         <div
            className={classNames("table__actions", {
               "table__actions--disabled": isDisabled,
            })}
         >
            {isEditing ? (
               <>
                  <Tooltip
                     key="cancel-tooltip"
                     content="Cancel"
                  >
                     <Icon
                        name="cross"
                        color={IconColor.HONOLULU_BLUE}
                        size="16"
                        onClick={onCancel}
                     />
                  </Tooltip>
                  {!hideDelete && (
                     <Tooltip
                        key="delete-tooltip"
                        content="Delete"
                     >
                        <Icon
                           name="trashBin"
                           color={IconColor.CERISE}
                           size="16"
                           onClick={onDelete}
                        />
                     </Tooltip>
                  )}
                  <Tooltip
                     key="save-tooltip"
                     content="Save"
                  >
                     <Icon
                        name="save"
                        color={IconColor.HONOLULU_BLUE}
                        size="16"
                        onClick={onSave}
                        aria-label="Save"
                        disabled={isSaveDisabled}
                     />
                  </Tooltip>
               </>
            ) : (
               <Tooltip
                  key="edit-tooltip"
                  content="Edit"
               >
                  <Icon
                     name="edit"
                     color={IconColor.HONOLULU_BLUE}
                     size="16"
                     onClick={onEdit}
                     disabled={isEditDisabled}
                  />
               </Tooltip>
            )}
         </div>
      </TableCell>
   )
}
